import { ResumeResult } from "../types";
import { api } from "./api";

export const conversationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getConversation: builder.query<ResumeResult, string>({
      query: (conversationId) => ({
        method: "GET",
        url: `/api/conversations/${conversationId}`,
      }),
    }),
  }),
});

export const { useGetConversationQuery } = conversationsApi;
